import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

const api = axios.create({
    baseURL: API_BASE,
    headers: {
        'Content-Type': 'application/json',
    },
    withCredentials: true,
});

api.interceptors.request.use((config) => {
    const token = window.localStorage.getItem('auth_token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

api.interceptors.response.use(
    (response) => response,
    async (error) => {
        if (error.response?.status === 401) {
            const refreshToken = window.localStorage.getItem('refresh_token');
            if (refreshToken && !error.config.__isRetryRequest) {
                try {
                    error.config.__isRetryRequest = true;
                    const res = await api.post('/auth/refresh', { refresh_token: refreshToken });
                    window.localStorage.setItem('auth_token', res.data.token);
                    window.localStorage.setItem('refresh_token', res.data.refresh_token);
                    return api(error.config);
                } catch (refreshError) {
                    window.localStorage.removeItem('auth_token');
                    window.localStorage.removeItem('refresh_token');
                    window.localStorage.removeItem('auth_user');
                }
            }
        }
        return Promise.reject(error);
    },
);

export default api;
